import axios from './axios';

export const ITEM_TYPES = {
    ENERGY_DRINK: 'energy_drink',
};

export const fetchUserItems = async () => {
    const response = await axios.get('/items');
    return response.data;
};

export const useItem = async (itemType, inventoryID) => {
    const response = await axios.post('/items/use', { itemType, inventoryID });
    return response.data;
};

export const awardItemToUser = async ({ userID, itemType, amount }) => {
    const response = await axios.post('/items/award', { userID, itemType, amount });
    return response.data;
};
